import React from 'react';
import { styled } from '@mui/material/styles';

import { Grid, Paper, Button, Typography, Grow } from '@mui/material';

import { useSelector } from 'react-redux';
import { selectCalc } from '../redux/calcSlice';

import ResultsFormDialog from './ResultsFormDialog';

import units from "../assets/json/units.json";
import tank from '../assets/images/tank.png'

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: 'transparent'
}));

const GradeLabel = styled(Paper)(({ theme }) => ({
  padding: `${theme.spacing(5)} ${theme.spacing(0)} ${theme.spacing(1.6)} ${theme.spacing(0)}`,
  backgroundColor: 'transparent'
}));

const BarHolder = styled(Paper)(({ theme }) => ({
  flexGrow : '1',
  backgroundColor: 'transparent'
}));

const Bar = styled(Paper)(({ theme }) => ({
  borderRadius: 0,
}));

const BarInner = styled(Paper)(({ theme }) => ({
  fontSize: '12px',
  padding:'4% 5%',
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  borderRadius: 0,
  height: 'calc(100% - 2px)'
}));

const ResultContainer = styled(Grid)(({ theme }) => ({
  background:'#F0F1F2',
  marginTop:theme.spacing(3),
}));

const Calculator = () => {
  const [open, setOpen] = React.useState(false);
  const calc = useSelector(selectCalc);

  const consumption1 = calc['consumption1']
  const consumption2 = calc['consumption2']

  const diff =  100 * Math.abs( ( consumption1 - consumption2 ) / ( (consumption1+consumption2)/2 ) );

  const thicknessUnits = units[calc.unit]["thickness"]["sign"]
  
  return (
    <ResultContainer id={'result-scroll'} style={{background:'#F0F1F2', marginTop:'2em'}} container item xs={12}>
      <Grid item xs={12} lg={4}>
        <Item style={{textAlign:'center'}} >
          <Typography variant="h2" component="h2">Calculation results</Typography>
          <Typography style={{ fontSize: '16px', lineHeight: '21px' }} variant="p" component="p">
            Material consumption {calc['steelGrade'][0]['OKGrade']}:<br/>
            <strong>{calc['consumption1'].toFixed(1)} metric tons</strong><br/>
            
            {Array.isArray(calc['steelGrade2']) &&
            <React.Fragment>
              Material consumption {calc['steelGrade2'][0]['OKGrade']}: <br/>
              <strong>{calc['consumption2'].toFixed(1)} metric tons</strong>
            </React.Fragment>}
          </Typography>

          {consumption1 && consumption2 &&
          <React.Fragment>
            <Typography style={{ marginBottom: '16px' }} variant="h2" component="h2">
              {diff.toFixed(1)}% saving
            </Typography>

            <Typography style={{ fontSize: '16px', lineHeight: '21px' }} variant="p" component="p">
              in material consumption using<br/>
              <strong>{consumption1 > consumption2 ? calc['steelGrade2'][0]['OKGrade'] : calc['steelGrade'][0]['OKGrade']}</strong><br/>compared to<br/><strong>{consumption1 > consumption2 ? calc['steelGrade'][0]['OKGrade'] : calc['steelGrade2'][0]['OKGrade']}</strong>
            </Typography>
          </React.Fragment>}

          <Button
            onClick={() => {
              setOpen(true);

              /* eslint-disable */
              if(parent && parent.dataLayer) {
                parent.dataLayer.push({
                  'event': 'StorageTankClickSendResultsBtn'
                });
              }
              /* eslint-enable */
            }}
            
            variant="contained">
            Send the results to your e-mail
          </Button>
        </Item>
      </Grid>
      <Grid item xs={12} lg={8}>
        <Grid container>
          <Grid container sx={{backgroundImage: { xs: `url(${tank})`, lg: 'none' }, minHeight: { xs: '380px' }, backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPosition: 'center center'}}>
            {Array.isArray(calc['steelGrade']) &&
            <Grid style={{ display:'flex', flexFlow:'column', height:'100%', zIndex:10 }} item xs={6} lg={3}>
              <GradeLabel style={{ textAlign:'right' }} sx={{ paddingLeft: { xs: '18px', lg: 0 } }}>{calc['steelGrade'][0]['OKGrade']}</GradeLabel>
                {calc.submitting === true ? false : true &&
                <BarHolder sx={{ paddingLeft: { xs: '18px', lg: 0 } }}>
                  {([...calc['res1']].reverse()).map((bar, idx) => {
                    return(
                      <Grow
                        key={idx}
                        in={true}
                        style={{ transformOrigin: 'center right' }}
                        {...(true ? { timeout: (calc['res1'].length < 4 ? 1000 : 3000) - (idx*200) } : {})}
                      >
                        <Bar style={{ height:`${100/calc['res1'].length}%`, marginLeft:'auto', marginRight:0, width:`calc(${(bar['thickness']/calc['res1'][0]['thickness'])*66}% + 40px)` }}><BarInner>{thicknessUnits === 'mm' ? Math.ceil(bar["thickness"]) : bar["thickness"].toFixed(2)} {thicknessUnits}</BarInner></Bar>
                      </Grow>
                    )}
                  )}
                </BarHolder>}
            </Grid>}

            <Grid item sx={{ display: { xs: 'none', lg: 'block' } }} lg={6}>
              <img style={{ width:'100%', padding:'26px', paddingTop:'34px', paddingBottom:0 }} src={tank} alt={'storage tank'} />
            </Grid>
            
            {Array.isArray(calc['steelGrade2']) &&
            <Grid style={{ display:'flex', flexFlow:'column', height:'100%', zIndex:10 }} item xs={6} lg={3}>
              <GradeLabel style={{ textAlign:'left' }} sx={{ paddingLeft: { xs: '18px', lg: 0 } }}>{calc['steelGrade2'][0]['OKGrade']}</GradeLabel>
              {calc.submitting === true ? false : true &&
              <BarHolder sx={{ paddingLeft: { xs: '18px', lg: 0 } }}>
                {([...calc['res2']].reverse()).map((bar, idx) => {
                  return(
                    <Grow
                    key={idx}
                      in={true}
                      style={{ transformOrigin: 'center left' }}
                      {...(true ? { timeout: 4000 - (idx*200) } : {})}
                    >
                      <Bar style={{ height:`${100/calc['res2'].length}%`, marginLeft:0, marginRight:'auto', width:`calc(${(bar['thickness']/calc['res2'][0]['thickness'])*66}% + 40px)`}}><BarInner style={{background:'#003057'}}>{thicknessUnits === 'mm' ? Math.ceil(bar["thickness"]) : bar["thickness"].toFixed(2)} {thicknessUnits}</BarInner></Bar> 
                    </Grow>
                  )}
                )}
              </BarHolder>} 
            </Grid>}
          </Grid>
          <Grid item xs={12}>
            <Item>
              <Typography style={{ fontSize: '16px', lineHeight: '21px', xtextAlign: 'center' }} variant="p" component="p">
                The picture above illustrates the number of plates and thickness by plate needed to build a tank with your specifications.
              </Typography>
            </Item>
          </Grid>
        </Grid>
      </Grid>
      <ResultsFormDialog open={open} handleClose={() => setOpen(false)} />
    </ResultContainer>
  );
}

export default Calculator;
